import React, { useEffect, useState } from 'react';
import IonicCalendar from '../Calendar/IonicCalendar';

interface DateDisplayProps {
  timestamp: number; // Timestamp as a number
  onDateChange: (newDate: number) => void;
}

const DateDisplay: React.FC<DateDisplayProps> = ({ timestamp, onDateChange }) => {
  const [date, setDate] = useState<number>(timestamp);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const formatDate = (date: number): string => {
    const dateObj = new Date(date);
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);

    if (dateObj.getDate() === tomorrow.getDate() && dateObj.getMonth() === tomorrow.getMonth() && dateObj.getFullYear() === tomorrow.getFullYear()) {
      return `Demain, ${dateObj.getHours()}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
    } else {
      return `${dateObj.getDate().toString().padStart(2, '0')}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getFullYear()}, ${dateObj.getHours()}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
    }
  };

  const handleCalendar = () => {
    setIsCalendarOpen(true);
  };

  const closeModal = () => {
    setIsCalendarOpen(false);
  };

  useEffect(() => {
    onDateChange(date);
  }, [date, onDateChange]);

  return (
    <div className="flex items-center relative">
      {date != null ? (
        <span className="text-green-500">{formatDate(date)}</span>
      ) : (
        <span className="text-ionic-gray italic text-xs mx-2">Choisir une date de retour</span>
      )}
      <button
        onClick={() => {
          handleCalendar();
        }}
        className={`text-red-500 text-xs underline ${date != null ? 'ml-3' : ''}`}
      >
        {date != null ? 'Changer' : 'Choisir'}
      </button>
      <IonicCalendar isOpen={isCalendarOpen} onClose={closeModal} date={date} setDate={setDate} />
    </div>
  );
};

export default DateDisplay;
